var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colTitle",
            fn: function ({ row }) {
              return [
                row.type != 10000
                  ? _c("LanguageInputEcho", {
                      attrs: { obj: row.title || {}, size: "mini" },
                    })
                  : _c("span", [_vm._v("链接")]),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: { size: "small", type: _vm.getTagType(row.status) },
                  },
                  [_vm._v(_vm._s(row.statusLabel))]
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                row.status === 1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDeactivate(row)
                          },
                        },
                      },
                      [_vm._v("停用")]
                    )
                  : _vm._e(),
                row.status === 2
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleActivate(row)
                          },
                        },
                      },
                      [_vm._v("启用")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDrawRecords(row)
                      },
                    },
                  },
                  [_vm._v("记录")]
                ),
                _c(
                  "el-popconfirm",
                  {
                    attrs: { title: "确定删除该活动？" },
                    on: {
                      confirm: function ($event) {
                        return _vm.handleDelete(row)
                      },
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: row.status === 2,
                            expression: "row.status === 2",
                          },
                        ],
                        staticStyle: {
                          color: "#f56c6c",
                          "padding-left": "8px",
                        },
                        attrs: {
                          slot: "reference",
                          type: "text",
                          size: "small",
                        },
                        slot: "reference",
                      },
                      [_vm._v(" 删除 ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("ActivityCreateDialog", {
        attrs: {
          "has-red-envelope-rain": _vm.hasRedEnvelopeRain,
          "has-agent-reward-box": _vm.hasAgentRewardBox,
          "has-loss-cashback": _vm.hasLossCashback,
          "has-total-deposit-reward": _vm.hasTotalDepositReward,
          "has-first-deposit-reward": _vm.hasFirstDepositReward,
          "has-spin-luck": _vm.hasSpinLuck,
          "has-sign-in": _vm.hasSignIn,
          visible: _vm.createDialogVisible,
          mode: _vm.dialogMode,
          "activity-data": _vm.editingRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.createDialogVisible = $event
          },
          success: _vm.handleDialogSuccess,
        },
      }),
      _c("SpinLuckLogDialog", {
        attrs: {
          visible: _vm.spinLuckLogDialogVisible,
          "act-id": _vm.spinLuckLogActId,
          "act-type": _vm.actType,
        },
        on: {
          "update:visible": function ($event) {
            _vm.spinLuckLogDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }